/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */

import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';
import Modal from '@components/modal/Modal';
import Colors from '@global/colors';

const DeleteCommentModal = ({ visible, onCancel, onConfirm }) => (
  <Modal
    transparent={true}
    visible={visible}
    animationType="fade"
    centered={true}
    zIndex={30}
    onClose={onCancel}>
    <View
      style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}
      pointerEvents="box-none">
      <View
        style={{
          width: 320,
          maxWidth: '90%',
          backgroundColor: Colors.white,
          borderRadius: 8,
          padding: 20,
        }}>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 12,
          }}>
          <SociollaText type="bold" style={{ fontSize: 16 }}>
            Delete Comment
          </SociollaText>
          <TouchableOpacity
            testID="delete-comment-modal-close"
            onPress={onCancel}>
            <Image
              source={require('@assets/img/icons/close-grey.svg')}
              style={{ width: 16, height: 16 }}
              width={16}
              height={16}
              svg={true}
            />
          </TouchableOpacity>
        </View>
        <SociollaText
          style={{ fontSize: 13, color: Colors.black, marginBottom: 20 }}>
          This action cannot be undone
        </SociollaText>
        <View style={{ flexDirection: 'row', gap: 12 }}>
          <TouchableOpacity
            testID="delete-comment-modal-cancel"
            onPress={onCancel}
            style={{
              flex: 1,
              alignItems: 'center',
              paddingVertical: 14,
              borderRadius: 8,
              borderWidth: 1,
              borderColor: Colors.grey0,
            }}>
            <SociollaText type="bold" style={{ fontSize: 14 }}>
              Cancel
            </SociollaText>
          </TouchableOpacity>
          <TouchableOpacity
            testID="delete-comment-modal-confirm"
            onPress={onConfirm}
            style={{
              flex: 1,
              alignItems: 'center',
              paddingVertical: 14,
              borderRadius: 8,
              backgroundColor: Colors.blue0,
            }}>
            <SociollaText
              type="bold"
              style={{ fontSize: 14, color: Colors.white }}>
              Delete
            </SociollaText>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  </Modal>
);

export default DeleteCommentModal;
